import { render, staticRenderFns } from "./UndueHardshipFSSurvey.vue?vue&type=template&id=5282461a"
import script from "./UndueHardshipFSSurvey.vue?vue&type=script&lang=ts"
export * from "./UndueHardshipFSSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports